<template>
  <div class="select-panel has-text-centered">
    <!-- todo: mayby vuex? -->
    <TextFileSelector @fileSelected="fileSelected" />
    <ZipFileSelector @fileSelected="fileSelected" />
  </div>
</template>

<script>
import TextFileSelector from './TextFileSelector'
import ZipFileSelector from './ZipFileSelector'

export default {
  components: {
    TextFileSelector,
    ZipFileSelector
  },
  methods: {
    fileSelected (files) {
      this.$emit('fileSelected', files)
    }
  }
}
</script>
